import { Routes } from '@angular/router'
import { LoginComponent } from './modules/auth/components/login.component'
import { CalendarComponent } from './modules/calendar/components/calendar/calendar.component'
import { authGuard } from './core/guards/auth.guard'
import { AuthenticatedLayoutComponent } from './modules/layouts/components/authenticated-layout.component'
import { UsersComponent } from './modules/users/components/users/users.component'
import { EditUserComponent } from './modules/users/components/edit-user/edit-user.component'
import { ProductsToPlanifyComponent } from './modules/products/components/products-to-planify/products-to-planify.component'
import { AffairComponent } from './modules/affairs/components/affair/affair.component'
import { AffairScheduleStepsComponent } from './modules/affairs/components/affair-schedule-steps/affair-schedule-steps.component'
import { AffairScheduleErosComponent } from './modules/affairs/components/affair-schedule-eros/affair-schedule-eros.component'
import { RedirectComponent } from './modules/auth/components/redirect/redirect.component'
import { InterventionsIncomingComponent } from './modules/interventions/components/interventions-incoming/interventions-incoming.component'
import { InterventionViewComponent } from './modules/interventions/components/intervention-view/intervention-view.component'
import { InterventionRescheduleComponent } from './modules/interventions/components/intervention-reschedule/intervention-reschedule.component'
import { HeatMapComponent } from './modules/products/components/products-to-planify/heat-map/heat-map.component'
import { TourCheckComponent } from './modules/tour/components/tour-check-component/tour-check.component'
import { OptimizedListComponent } from './modules/tour/components/optimized-list/optimized-list.component'
import { InterventionsToRescheduleComponent } from './modules/interventions/components/interventions-to-reschedule/interventions-to-reschedule.component'
import { AffairPoolOptimizationComponent } from './modules/affairs/components/affair-pool-optimization/affair-pool-optimization.component'
import { JobsComponent } from './modules/admin/components/jobs/jobs.component'
import { WebhooksComponent } from './modules/admin/components/webhooks/webhooks.component'
import { OptimizationDebugComponent } from './modules/admin/components/optimization-debug/optimization-debug.component'
import { OptimizationRunDetailComponent } from './modules/admin/components/optimization-run-detail/optimization-run-detail.component'
import { OptimizationDiagnosticComponent } from './modules/admin/components/optimization-diagnostic/optimization-diagnostic.component'
import { OptimizationDiagnosticDetailComponent } from './modules/admin/components/optimization-diagnostic-detail/optimization-diagnostic-detail.component'
import { LogsComponent } from './modules/admin/components/logs/logs.component'
import { TablotSettingsComponent } from './modules/admin/components/tablot-settings/tablot-settings.component'
import { RoutabilityTestComponent } from './modules/admin/components/routability-test/routability-test.component'
import { SectorSettingsComponent } from './modules/sectors/components/sector-settings/sector-settings.component'

export const routes: Routes = [
  { path: '', redirectTo: 'calendar', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'redirect', component: RedirectComponent },
  {
    path: '',
    component: AuthenticatedLayoutComponent,
    canActivateChild: [authGuard],
    children: [
      { path: 'calendar', component: CalendarComponent },
      { path: 'users/:id', component: EditUserComponent },
      { path: 'users', component: UsersComponent },
      { path: 'products-to-planify', component: ProductsToPlanifyComponent },
      {
        path: 'interventions-incoming',
        component: InterventionsIncomingComponent,
      },
      {
        path: 'interventions-to-reschedule',
        component: InterventionsToRescheduleComponent,
      },
      {
        path: 'affair/:mlRef/schedule',
        component: AffairScheduleStepsComponent,
      },
      {
        path: 'affair/:mlRef/schedule-eros',
        component: AffairScheduleErosComponent,
      },
      { path: 'affair/:mlRef', component: AffairComponent },
      {
        path: 'intervention/:id/view/:erpSource',
        component: InterventionViewComponent,
      },
      {
        path: 'intervention/:id/reschedule/:erpSource',
        component: InterventionRescheduleComponent,
      },
      {
        path: 'optimization',
        component: OptimizedListComponent,
      },
      { path: 'tour-check', component: TourCheckComponent },
      { path: 'pool-optimization', component: AffairPoolOptimizationComponent },
      { path: 'admin/jobs', component: JobsComponent },
      { path: 'admin/webhooks', component: WebhooksComponent },
      {
        path: 'admin/optimization-debug',
        component: OptimizationDebugComponent,
      },
      {
        path: 'admin/optimization-debug/:runId',
        component: OptimizationRunDetailComponent,
      },
      {
        path: 'admin/optimization-diagnostic',
        component: OptimizationDiagnosticComponent,
      },
      {
        path: 'admin/optimization-diagnostic/:affairId',
        component: OptimizationDiagnosticDetailComponent,
      },
      { path: 'admin/logs', component: LogsComponent },
      { path: 'admin/tablot-settings', component: TablotSettingsComponent },
      {
        path: 'admin/routability-test',
        component: RoutabilityTestComponent,
      },
      { path: 'admin/sectors', component: SectorSettingsComponent },
    ],
  },
  { path: '**', redirectTo: 'calendar' },
]
